<template>
    <div>
      <h1>Applications</h1>
      <div class="description text-secondary mb-3">
        Teonet applications list page.
      </div>
    </div>
  </template>